export const ACTION_TYPES_BY_PLATFORM = {
    pluglead: [
        { value: 'webhook_call', label: 'Chamada de Webhook para PlugLead' },
    ],
    manual: [
        { value: 'webhook_call', label: 'Chamada de Webhook' },
    ],
    active_campaign: [
        { value: 'webhook_call', label: 'Chamada de Webhook' },
        { value: 'create_lead', label: 'Criar contato no ActiveCampaign' },
    ],
};

export const DEFAULT_ACTIONS_BY_PLATFORM = {
    pluglead: [{ type: 'webhook_call', config: { webhook_url: '' } }],
    manual: [],
    active_campaign: [],
};

export function generateDescription(event, planId, platform, community) {
    const triggers = {
        'payments.confirmed': 'um pagamento for confirmado',
        'payments.pix_generated': 'um Pix for gerado',
        'payments.checkout_dropped': 'um checkout for abandonado',
    };
    const destinations = {
        pluglead: 'PlugLead',
        manual: 'um endpoint externo via webhook',
        active_campaign: 'ActiveCampaign',
    };

    if (!event || !platform) return null;

    const plan = community?.plans?.find(p => String(p.id) === String(planId));
    const planLabel = plan ? `no plano "${plan.label}"` : 'em qualquer plano';
    const trigger = triggers[event] || event;
    const dest = destinations[platform] || platform;

    return `Quando ${trigger} ${planLabel}, o Ginastee irá enviar os dados do comprador para ${dest}.`;
}

let _keyCounter = 0;
export function newActionKey() {
    return `ak_${++_keyCounter}_${Date.now()}`;
}
